<template>
  <div class="interiorzone">
    <h2 class="subheading">工商认证</h2>
    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-organ-list">
          <li class="hd">
            <span>序号</span>
            <span>公司名称</span>
            <span class="organizationCode">社会信用代码</span>
            <span class="phone">注册手机</span>
            <span>法人姓名</span>
            <span class="userole">身份</span>
            <span class="userphone">法人手机</span>
            <span class="planBank">拟分配贴现行</span>
            <span>证件证照</span>
            <span>操作</span>
            <span>提交时间</span>
            <span>审核结果</span>
          </li>
          <li  v-for="(item,index) in companylist" v-bind:key="index">
            <span>{{index + 1}}</span>
            <span>{{item.companyName}}</span>
            <span  class="organizationCode">{{item.organizationCode}}</span>
            <span class="phone">{{item.mobile}}</span>
            <span>{{item.legalPersonName}}</span>
            <span class="userole">{{item.role==1?'法人':'代理'}}</span>
            <span class="userphone">{{item.legalPhone}}</span>
            <span class="planBank">{{item.planBank}}</span>
            <span class="lookpanel">
              <div>
                <a href="javascript:void(0);" @click="looklicense(item.uid,item.organizationCode)">营业执照</a>
                <a href="javascript:void(0);" @click="lookidentity(item.uid,1,item.organizationCode)">法人</a>
                <a href="javascript:void(0);" @click="lookidentity(item.uid,2,item.organizationCode)" v-if="item.role!=1">代理人</a>
                <a href="javascript:void(0);" @click="lookletter(index)">协议</a> 
                <!-- letterUrl 协议在这里-->
              </div>
            </span>
            <span class="redio material"> <a href="javascript:void(0);"  @click='download(item.orderId,item.legalPersonName)' >资料下载</a> <a href="javascript:void(0);" @click="reginfoinpu(item.organizationCode,item.legalPhone,item.uid,index)">信息录入</a></span>
            <span class="infoperations">{{item.time}}</span>
            <span class="infoperation redio"><a  href="javascript:void(0);"   @click="opentrial(item.uid,item.organizationCode,item.orderId)">审核</a></span>
            
          </li>
        </ul>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(pagenum)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>
    <div class="zzc" v-if="lkyyzc">
      <div class="iconfont icon-31guanbi coloseide"  @click="yyzcolese()"></div>
      <picture>
        <img :src="imgpath" class="yyzc" :class="routpic">
      </picture>
      <div class="iconfont icon-icons06 route" title="旋转" alt='旋转'  @click.stop="rotatepic()"></div>
      <div class="zzcdatainfo  iconfont icon-jiantou11 upbig" v-if="!lookinfo" @click.stop="openretract()">
        查看信息
      </div>
      <div class="zzcdatainfo dowsmll" v-if="lookinfo">
        <div class="retract  iconfont icon-jiantou12 " @click.stop="openretract()"></div>
        <ul>
          <li><label>名称：</label><span>{{licencedata.cmpName}}</span></li>
          <li><label>社会统一信用代码：</label><span>{{licencedata.socialCode}}</span></li>
          <li><label>类型：</label><span v-if="!ischage">{{licencedata.cmpTypeName}}</span><input type="text"  class="zzdatatext"  v-model="ncmpTypeName"  v-else></li>
          <li><label>住所：</label><span  v-if="!ischage">{{licencedata.place}}</span><input type="text"  class="zzdatatext"  v-model="nplace"  v-else></li>
          <li><label>法人：</label><span>{{licencedata.legalName}}</span></li>
          <li><label>注册资本：</label><span  v-if="!ischage">{{licencedata.runCode}}</span><input type="text" v-model="nrunCode"  class="zzdatatext"   v-else>万元</li>
          <li><label>成立日期：</label><span  v-if="!ischage">{{licencedata.buildTime|formatDate}}</span><input type="text" v-model="ncreateTime"  class="zzdatatext"   v-else></li>
          <li><label>营业期限：</label><span  v-if="!ischage">{{licencedata.openEndTime}}</span><input type="text" v-model="nmodifyTime"  class="zzdatatext"  v-else></li>
          <li><label>经营范围：</label><span  v-if="!ischage">{{licencedata.scope}}</span><input type="text" v-model="nscope"  class="zzdatatext"  v-else></li>
          <li><label>签发时间：</label><span  v-if="!ischage">{{licencedata.giveTime|formatDate}}</span><input type="text" v-model="ngiveTime"  class="zzdatatext"  v-else></li>
          <li><label>签发机关：</label><span  v-if="!ischage">{{licencedata.registerPlace}}</span><input type="text" v-model="nregisterPlace"  class="zzdatatext"  v-else></li>
        </ul>
        <button class="editbtn" v-if="!ischage" @click="goyyzz()">修改</button>
        <button class="editbtn" v-else @click="licencechange()">提交</button>
      </div>
    </div>
    <div class="zzc leetbox" v-if="lkletter"  @click="closeimg()" >
      <!-- 查看贴现协议 -->
      <img :src="letterimg" @click="closeimg()" class="leetimg">
    </div>
    <div class="zzc" v-if="lkidentity">
      <picture>
        <img :src="imgpath" class="identity" ref="inputa" :class="routpic">
      </picture>
      <div class="iconfont icon-31guanbi coloseide"  @click="yyzcolese()"></div>
      <div class="iconfont icon-icons06 route" title="旋转" alt='旋转'  @click.stop="rotatepic()"></div>
      <div class="previous iconfont icon-zuo-yuan" @click.stop="prepic()" v-if="imgpathindex==1"></div>
      <div class="next iconfont icon-you-yuan" @click.stop="nextpic()" v-if="imgpathindex==0"></div>
      <div class="zzcdatainfo  iconfont icon-jiantou11 upbig" v-if="!lookinfo" @click.stop="openretract()">
        查看信息
      </div>
      <div class="zzcdatainfo dowsmll" v-if="lookinfo">
        <div class="retract  iconfont icon-jiantou12 " @click.stop="openretract()"></div>
        <ul>
          <li><label>姓名：</label><span>{{nowusinfo.personName}}</span><input type="text" class="datatext noedit" v-model="npersonName"></li>
          <li><label>性别：</label><span v-if="!ischage">{{nowusinfo.sexType==1?'男':'女'}}</span><input type="text"  class="datatext"  v-model="nsexType"  v-else></li>
          <li><label>出生日期：</label><span  v-if="!ischage">{{nowusinfo.birthday|formatDate}}</span><input type="text"  class="datatext"  v-model="nbirthday"  v-else></li>
          <li><label>民族：</label><span  v-if="!ischage">{{nowusinfo.nationality}}</span><input type="text" v-model="nnationality"  class="datatext"   v-else></li>
          <li><label>地址：</label><span  v-if="!ischage">{{nowusinfo.addr}}</span><input type="text" v-model="newaddr"  class="datatext"   v-else></li>
          <li><label>身份证号：</label><span  v-if="!ischage">{{nowusinfo.idCardCode}}</span><input type="text" v-model="nidCardCode"  class="datatext"   v-else></li>
          <li><label>签发机关：</label><span  v-if="!ischage">{{nowusinfo.issuePlace}}</span><input type="text" v-model="nissuePlace"  class="datatext"  v-else></li>
          <li><label>有效期：</label><span  v-if="!ischage">{{nowusinfo.startTime|formatDate}}-{{nowusinfo.endTime|formatDate}}</span><span  v-else><input type="text" v-model="nstartTime"   class="datetext"  />-<input type="text"   class="datetext"   v-model="nendTime"/></span></li>
        </ul>
        <button class="editbtn" v-if="!ischage" @click="gochange()">修改</button>
        <button class="editbtn" v-else @click="cardchange()">提交</button>
      </div>
    </div>
    <div class='adopt' v-if="adoptpanel">
    <h2>确认此订单审核通过并已在资方完成注册？</h2>
    <div class="btn-confirm"><button class="addok" @click="orderadopt()">确认</button> <button class="addok" @click="colosepanel(1)">取消</button></div>
    </div>
    <div class="rejectbox" v-if="rejectboxpanel">
      <h2>请填写驳回理由：</h2>
      <textarea v-model="whatreject"></textarea>
      <div class="btn-confirm"><button class="addok"  @click="orderreject()">确认</button> <button class="addno" @click="colosepanel(2)">取消</button></div>
    </div>
    <div class="zzc" v-if="isinput">
      <div class="infoinputbox">
        <p class="clearss" @click="clearInpusd">X</p>
        <template v-if="operationstep==1">
          <h2>Step1:公司信息录入-{{nowcompany}}</h2>
          <div class="infomark"><span>工商登记信息</span></div>
          <div class="reginfo">
            <div class="reginfolist rilhd">
              <div class="ril1">机构类型</div>
              <div class="ril2">国标行业分类（1）</div>
              <div class="ril3">国标行业分类（2）</div>
              <div class="ril4">企业所有制类型</div>
              <div class="ril5">企业类型</div>
              <div class="ril6">客户细类</div>
              <div class="ril8  maxw">注册地</div>
              <div class="ril9 smlw">所在省/市</div>
              <div class="ril10 smlw">营业执照签发城市</div>
              <div class="ril11">签发地邮编</div>
            </div>
            <div class="reginfolist">
              <div class="ril1">
                <div class="selector">
                  <span class="iconfont icon-jiantou12 downselect">{{businesstype}}</span>
                  <ul class="drop-down">
                    <li v-for="(item,index) in mechanism" @click="confirmtype(item.id,item.name)"  :key="index">{{item.name}}</li>
                  </ul>
                </div>
              </div>
              <div class="ril2">{{industryName}}</div>
              <div class="ril3">{{coName}}</div>
              <div class="ril4">
                <div class="selector">
                  <span class="iconfont icon-jiantou12 downselect">{{ownershipstyle}}</span>
                  <ul class="drop-down"> 
                    <li v-for="(item,index) in ownership" :data-id="item.id" :key="index" @click="setownership(item.name,item.id)">{{item.name}}</li>
                  </ul>
                </div>
              </div>
              <div class="ril5">
                <div class="selector distraction">
                  <span class="iconfont icon-jiantou12 downselect">{{enterprisestype}}</span>
                  <ul class="drop-down"> 
                      <li v-for="(item,index) in enterprisesTypearray" :data-id="item.id" :key="index" @click="setenterprises(item.name,item.id)">{{item.name}}</li>
                  </ul>
                </div>
              </div>
              <div class="ril6">
                <div class="selector distraction">
                  <span class="iconfont icon-jiantou12 downselect">{{subclass}}</span>
                  <ul class="drop-down"> 
                      <li v-for="(item,index) in branchtype" :data-id="item.id" :key="index" @click="setsubclass(item.name,item.id)">{{item.name}}</li>
                  </ul>
                </div>
              </div>
              <div class="ril8 maxw">
                <input type="text" class="smllinput" v-model="regaddress">
              </div>
              <div class="ril9 smlw">
                <div class="jointsearch">
                  <span @click="getprovince(1)" class="iconfont icon-jiantou12" :class="selectprovince?'pro':''" >{{cityval!=''?cityval:nowpro+'-'+nowct+'-'+nocou}}</span>
                  <ul>
                    <template v-if="selectprovince">
                      <li v-for="(item,index) in provincelist" :key="index" @click="getcity(item.provinceId,item.provinceName,1)">{{item.provinceName}}</li>
                    </template>
                    <template v-else-if="nowpro!='所在省'&&countylist.length=='0'">
                      <li v-for="(item,index) in citylist" :key="index" @click="setcity(item.cityId,item.cityName,1)">{{item.cityName}}</li>
                    </template>
                    <template v-else-if="!selectprovince&&nowct!='市'">
                      <li v-for="(item,index) in countylist" :key="index" @click="setcounty(item.areaId,item.areaName,1,'')">{{item.areaName}}</li>
                    </template> 
                  </ul>
                </div>
              </div>
              <div class="ril10 smlw">
                <div class="jointsearch">
                  <span @click="getprovince(2)" class="iconfont icon-jiantou12" :class="setectissueaddr?'pro':''">{{odcity!=''?odcity:issupro+'-'+issuct+'-'+issucou}}</span>
                  <ul>
                    <template  v-if="setectissueaddr">
                      <li v-for="(item,index) in provincelist" :key="index" @click="getcity(item.provinceId,item.provinceName,2)">{{item.provinceName}}</li>
                    </template>
                    <template  v-else-if="issupro!='签发省'&& issuctylist.length=='0'">
                      <li v-for="(item,index) in citylist2" :key="index" @click="setcity(item.cityId,item.cityName,2)">{{item.cityName}}</li>
                    </template>
                    <template v-else-if="issupro!='签发省'&&issuct!='市'">
                      <li v-for="(item,index) in issuctylist" :key="index" @click="setcounty(item.areaId,item.areaName,2,'')">{{item.areaName}}</li>
                    </template>
                  </ul>
                </div>
              </div>
              <div class="ril11"><input type="text" v-model="zipcode"></div>
            </div>
          </div>
          <div class="infomark"><span>公司经营信息</span></div>
          <div class="reginfo">
            <div class="reginfolist rilhd">
              <div class="ril1">注册资本（元）</div>
              <div class="ril2">实收资本（元）</div>
              <div class="ril3">职工人数</div>
              <div class="ril4">年销售额（元）</div>
              <div class="ril9">资产总额（元）</div>
              <div class="ril6"></div>
              <div class="ril8"></div>
              <div class="ril5"></div>
              <div class="ril10"></div>
              <div class="ril11"></div>
            </div>
            <div  class="reginfolist selfinput">
              <div class="ril1"><input type="text" v-model="regcapital"></div>
              <div class="ril2"><input type="text" v-model="paidcapital"></div>
              <div class="ril3"><input type="text" v-model="staffnumber"></div>
              <div class="ril4"><input type="text" v-model="salesvolume"></div>
              <div class="ril9"><input type="text" v-model="totalassets"></div>
              <div class="ril6"></div>
              <div class="ril8"></div>
              <div class="ril5"></div>
              <div class="ril10"></div>
              <div class="ril11"></div>
            </div>
          </div>
          <div class="fmbtn">
            <div class="fmbtn-ok" @click="saveinfoa()">下一步</div>
            <div class="fmbtn-no" @click="stopinput()">取消</div>
          </div>
        </template>
        <template v-if="operationstep==2">
          <h2>Step2：高管&股东信息录入-{{nowcompany}}</h2>
          <div class="infomark"><span>高管信息（默认为法人）</span></div>
          <div class="reginfo">
            <div class="reginfolist management rilhd">
              <div class="mril1">姓名</div>
              <div class="mril2">身份证编号</div>
              <div class="mril3">证件登记日期</div>
              <div class="mril4">证件到期日期</div>
              <div class="mril5">居住地</div>
              <div class="mril6">证件签发城市</div>
              <div class="mril7">担任职务</div>
            </div>
            <div class="reginfolist management" v-for="(item,index) in ceodata" :key="index">
              <div class="mril1"><input type="text" v-model="item.name" @change="editceoinfo(index)"></div>
              <div class="mril2"><input type="text" v-model="item.idCode"  @change="editceoinfo(index)"></div>
              <div class="mril3"> <input type="text" v-model="item.regDate"  @change="editceoinfo(index)"></div>
              <div class="mril4"> <input type="text" v-model="item.expiryDate"  @change="editceoinfo(index)"></div>
              <div class="mril5"> <input type="text" v-model="item.address"  @change="editceoinfo(index)"></div>
              <div class="mril6">
                <div class="jointsearch">
                  <span @click="getprovince(3)" class="iconfont icon-jiantou12" :class="setectmanageeaddr?'pro':''">{{managepro}}-{{managect}}-{{managecou}}</span>
                  <ul>
                    <template  v-if="setectmanageeaddr">
                      <li v-for="(item,index) in provincelist" :key="index" @click="getcity(item.provinceId,item.provinceName,3)">{{item.provinceName}}</li>
                    </template>
                    <template  v-else-if="managepro!='签发省'&& managectylist.length=='0'">
                      <li v-for="(item,index) in citylist3" :key="index" @click="setcity(item.cityId,item.cityName,3)">{{item.cityName}}</li>
                    </template>
                    <template v-else-if="managepro!='签发省'&&managect!='市'">
                      <li v-for="(item,num) in managectylist" :key="num" @click="setcounty(item.areaId,item.areaName,3,index)">{{item.areaName}}</li>
                    </template>
                  </ul>
                </div>
              </div>
              <div class="mril7">
                <div class="selector">
                  <span class="iconfont icon-jiantou12 downselect">{{item.relationShipDesc==''?'选择职务类型':item.relationShipDesc}}</span>
                  <ul class="drop-down"> 
                    <li v-for="(item,key) in jobstyle" :key="key" @click="setduties(item.name,item.id,index)">{{item.name}}</li> 
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="infomark"><span>股东信息（银行返回，总持股比例＞50%）</span></div>
          <div class="reginfo spring">
            <div class="reginfolist stockholder rilhd">
              <div class="ril1">名称</div>
              <div class="ril2">证件类型</div>
              <div class="ril3">证件编号</div>
              <div class="ril4">证件登记日</div>
              <div class="ril5">证件到期日</div>
              <div class="ril6">证件签发城市</div>
              <div class="ril8">出资方式</div>
              <div class="ril9">出资比例%</div>
              <div @click.stop="increaseshareholder()">增加</div>
            </div>
            <div class="reginfolist  stockholder" v-for="(item ,index) in stockholderinfo" :key="index">
              <div class="ril1"><input type="text" v-model="item.name"></div>
              <div class="ril2">
                <div class="selector">
                  <span class="iconfont icon-jiantou12 downselect">{{item.certType==''?'选择证件类型':item.certType|idcartype}}</span>
                  <ul class="drop-down"> 
                    <li v-for="(item,index2) in certificatetype" :key="index2" @click="selectidcartype(index,item.name,item.id)">{{item.name}}</li> <!--传递当前的索引 修改 stockholderinfo 中 对应索引的 conType -->
                  </ul>
                </div>
              </div>
              <div class="ril3"><input type="text" v-model="item.idCode" @change="pushrenovation(index)"></div>
              <div class="ril4"><input type="text" v-model="item.regDate"  @change="pushrenovation(index)"></div>
              <div class="ril5"><input type="text" v-model="item.expiryDate"  @change="pushrenovation(index)"></div>
              <div class="ril6">
                <div class="jointsearch">
                  <span @click="getprovince(4)" class="iconfont icon-jiantou12" :class="setectholdereaddr?'pro':''">{{item.regCityCodeDesc!=''?item.regCityCodeDesc:item.val1+'-'+item.val2+'-'+item.val3}}</span>
                  <ul>
                    <template  v-if="setectholdereaddr">
                      <li v-for="(item,k1) in provincelist" :key="k1" @click="getcity(item.provinceId,item.provinceName,4,index)">{{item.provinceName}}</li>
                    </template>
                    <template  v-else-if="holderpro!='签发省'&& holderctylist.length=='0'">
                      <li v-for="(item,k2) in citylist4" :key="k2" @click="setcity(item.cityId,item.cityName,4,index)">{{item.cityName}}</li>
                    </template>
                    <template v-else-if="holderpro!='签发省'&&holderct!='市'">
                      <li v-for="(item,k3) in holderctylist" :key="k3" @click="setcounty(item.areaId,item.areaName,4,index)">{{item.areaName}}</li>
                    </template>
                  </ul>
                </div>
              </div>
              <div class="ril8">
                <div class="selector">
                  <span class="iconfont icon-jiantou12 downselect">{{item.investmentCodeDesc==''?'选择出资方式':item.investmentCodeDesc}}</span>
                  <ul class="drop-down">
                    <li v-for="(item,index2) in contributiontype" :key="index2" @click="selecttoinvest(index,item.name,item.id)">{{item.name}}</li> <!--传递当前的索引 修改 stockholderinfo 中 对应索引的 conType -->
                  </ul>
                </div>
              </div>
              <div class="ril9"><input type="text" v-model="item.investmentProp"  @change="pushrenovation(index)"></div>
              <div @click.stop="delectshareholder(index)">删除</div>
            </div>
          </div>
          <div class="fmbtn">
            <div class="fmbtn-ok" @click="toexecutivesinfo()">下一步</div>
            <div class="fmbtn-no" @click="previouset()">上一页</div>
          </div>
        </template>
        <template v-if="operationstep==3">
          <h2>Step3：受益人信息录入-{{nowcompany}}</h2>
          <div class="bluebox" @click="setupbeneficiary()">设定法人为受益人</div>
          <div class="infomark"><span>受益人信息（银行返回）</span></div>
          <div class="reginfo">
            <div class="reginfolist rilhd beneficiary">
              <div class="ril1">姓名</div>
              <div class="ril2">证件类型</div>
              <div class="ril3">证件号码</div>
              <div class="ril4">证件签发日</div>
              <div class="ril9">证件到期日</div>
              <div class="ril6">联系电话</div>
              <div class="ril8">通讯地址</div>
            </div>
            <div  class="reginfolist selfinput beneficiary" v-for="(item,index) in beneficiary" :key="index">
              <div class="ril1"><input type="text" v-model="item.name"  @change="pushset(index)"></div>
              <div class="ril2">
                <div class="selector">
                  <span class="iconfont icon-jiantou12 downselect">{{item.certType==''?'选择证件类型':item.beneficiarycarid}}</span>
                  <ul class="drop-down"> 
                    <li v-for="(item,index2) in certificatetype" :key="index2" @click="setidcartype(index,item.name,item.id)">{{item.name}}</li> <!--传递当前的索引 修改 stockholderinfo 中 对应索引的 conType -->
                  </ul>
                </div>
              </div>
              <div class="ril3"><input type="text" v-model="item.idCode"  @change="pushset(index)"></div>
              <div class="ril4"><input type="text" v-model="item.regDate"  @change="pushset(index)"></div>
              <div class="ril9"><input type="text" v-model="item.expiryDate"  @change="pushset(index)"></div>
              <div class="ril6"><input type="text" v-model="item.mobile"  @change="pushset(index)"></div>
              <div class="ril8"><input type="text" v-model="item.address"  @change="pushset(index)" ></div>
            </div>
          </div>
          <div class="fmbtn">
            <div class="fmbtn-ok" @click="openraup()">提交</div>
            <div class="fmbtn-no" @click="previouset()">上一页</div>
          </div>
        </template>
      </div>
    </div>
    <div class="zzc" v-if="tisopentrial" >
      <div class="trialpanel" :class="[istra?'limpid':'',isremindok?'limpid':'',isremindno?'limpid':'']">
        <h2>审核结果 <span class="iconfont icon-31guanbi closepanel" @click.stop="closetrial()"></span></h2>
        <div class="triallist">
          <ul>
            <li>银行名称</li>
            <li>当前状态</li> 
            <li>银行反馈</li> 
            <li>操作</li>   
          </ul>
          <ul v-for="(item , index) in trialbankinfo" :key="index" class="unul">
            <li class="ubankname">{{item.discountBankName}}</li>
            <li>{{item.status==0?'等待审核':item.status==1?'审核通过':item.status==2?'未通过':''}}</li>
            <li>{{item.statusDesc}}</li>
            <li><span @click="openbankadopt(item.id)">通过</span><span @click="openbankrejec(item.id)">驳回</span></li>
          </ul>
        </div>
        <div class="savebox">
          <div class="tosave" @click="openpanel(1)">通过</div>
          <div class="tocanel" @click="openpanel(2)">驳回</div>
        </div>
      </div>

    <div class="okrz" v-if="isremindok">
      <h2>请确认审核是否通过？</h2>
      <div class="okrzbtnbox">
        <div class="okrzbtn fgfg" @click="bankadopt()">确认</div>
        <div class="okrzbtn" @click="bankcolse(1)">取消</div>
      </div>
    </div>
    <div class="okrz" v-if="isremindno">
      <h2>确认审核是否驳回？</h2>
      <div class="okrzbtnbox">
        <div class="okrzbtn fgfg" @click="bankrejec()">确认</div>
        <div class="okrzbtn" @click="bankcolse(2)">取消</div>
      </div>
    </div>

    </div>
    <div class="okrz" v-if="isrzup">
      <h2>确认提交此认证申请？</h2>
      <div class="okrzbtnbox">
        <div class="okrzbtn fgfg" @click="subbeneficiary()">确认</div>
        <div class="okrzbtn" @click="norzup()">取消</div>
      </div>
    </div>
  </div>
</template>
<script>
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import JsPDF from 'jspdf'
//import FileReader from 'file-reader'
export default {
  data() {
    return {
      pagenum:0,
      currentPage:1,
      pageSize:10,
      companyName:'',
      companylist:[],
      ifpageshow:false,
      imgpath:'',
      lkyyzc:false,
      lkidentity:false,
      imgpathlist:[],
      imgpathindex:0,
      picrecord:[],
      adoptpanel:false,
      rejectboxpanel:false,
      whatreject:'',
      orderid:'',
      nowusinfo:[],
      lookinfo:false,
      npersonName:'',
      nbirthday:'',
      nsexType:'',
      newaddr:'',
      nnationality:'',
      nidCardCode:'',
      nissuePlace:'',
      nstartTime:'',
      nendTime:'',
      ischage:false,
      rotate:0,
      routpic:'',
      licencedata:[],
      ncmpTypeName:'',
      nplace:'',
      nrunCode:'',
      ncreateTime:'',
      nmodifyTime:'',
      nscope:'',
      ngiveTime:'',
      nregisterPlace:'',
      tisopentrial:false,
      trialbankinfo:[],
      istra:false,
      nuid:'',
      norganizationCode:'',
      lkletter:false,
      isinput:false,
      inputcompany:true,
      operationstep:1,
      nowcompany:"",
      mechanism:[],
      enterprisesTypearray:[],
      ownership:[],
      provincelist:[],
      selectprovince:true,
      setectissueaddr:true,
      setectholdereaddr:true,
      citylist:[],
      citylist2:[],
      nowpro:'所在省',
      nowpid:'',
      nowct:'市',
      nowid:'',
      nocou:'区县',
      nouid:'',
      issupro:"签发省",
      issupid:'',
      issuct:"市",
      issucid:'',
      issucou:'区县',
      issucoid:'',
      businesstype:'法人企业',
      branchtype:[],
      countylist:'',
      issuctylist:[],
      industryName:'',
      industryCode:'',
      coName:'',
      setectmanageeaddr:true,
      managepro:'签发省',
      managect:'市',
      managecou:'区县',
      holderpro:'签发省',
      holderct:'市',
      holdercou:'区县',
      citylist4:[],
      citylist3:[],
      managectylist:[],
      holderctylist:[],
      managepid:'',
      managecid:'',
      managecoid:'',
      managername:'',//高管姓名
      managercode:'',//高管证件码
      managerregdate:'',//证件登记日
      managerexpiredate:'',//到期日
      mresideaddres:"",//居住地
      certificatetype:[],//证件类型
      jobstyle:[],//职务类型
      contributiontype:[],//出资类型
      regcapital:'',//注册资本
      paidcapital:'',// Paid in capital 实收资本
      staffnumber:'',
      salesvolume:'',
      totalassets:'',
      ceodata:[],
      stockholderinfo:[],
      beneficiary:[],
      regaddress:"",
      ownershipstyle:'私人控股企业',
      ownershipid:'170',
      enterprisestype:'有限责任公司',
      enterprisesid:'100150',
      subclass:'有限责任公司',
      subclassid:'205',
      businessid:'0101',
      zipcode:'',
      offAreaCode:'',
      nowindex:'',
      legalpdf:'',
      burl:'',
      lurl:'',
      legalinfo:[],
      isrzup:false,
      basicIncinfo:[],
      judgeid:'',
      isremindok:false,
      isremindno:false,
      cityval:'',
      odcity:''
    }
  },
  mounted:function() {
    this.readlist();
  },
  methods: {
    handleAjax(){

    },
    rotatepic(){
      this.rotate=Number(this.rotate)+1
      if(this.rotate<4){
        this.routpic="routpic"+this.rotate
        return false
      }
      else{
        this.rotate=''
        this.routpic=''
      }
    },
    licencechange(){
      this.ajax.post('/auth/piaoEditBusnissLicence',{bizContent:{blicenceId:this.licencedata.blicenceId,cmpName:this.licencedata.cmpName,socialCode:this.licencedata.socialCode,place:this.nplace,cmpTypeName:this.ncmpTypeName,legalName:this.licencedata.legalName,buildTime:this.ncreateTime,openEndTime:this.nmodifyTime,giveTime:this.ngiveTime,runCode:this.nrunCode,registerPlace:this.nregisterPlace,scope:this.nscope}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            swal({
              text: '修改成功',
              timer: 3000,
              icon: "success",
              buttons: false
            })
            this.lookinfo=false
            this.ischage=false
            this.lkyyzc=false
            this.readlist()
          }
        }
      )
    },
    toexecutivesinfo(){
      this.seniorexecutiveinfo()
     
    },
    previouset(){
      this.operationstep=this.operationstep-1
    },
    stopinput(){
      this.isinput=false
    },
    setsubclass(val,key){
      this.subclass=val
      this.subclassid=key
    },
    setownership(val,key){
      this.ownershipstyle=val
      this.ownershipid=key
    },
    setenterprises(val,key){
      this.enterprisestype=val
      this.enterprisesid=key
    },
    loadata(val){
      this.currentPage=val
      this.readlist()
    },
    readlist(){
      this.ajax.post('/auth/piaoOrderList',{bizContent:{currentPage:this.currentPage,pageSize:this.pageSize,orderType:'5',orderSubType:'1',status:'100'}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.pagenum=result.data.data.page
            this.pagenum>1?this.ifpageshow=true:this.ifpageshow=false
            this.companylist=result.data.data.data
            //console.log(result.data.data.data)
          }
        }
      )
    },
    openpanel(key){
      this.whatreject=""
      this.istra=true
      if(key==1){
        this.adoptpanel=true
      }
      else if(key==2){
        this.rejectboxpanel=true
      }
    },
    orderadopt(){
      this.ajax.post('/auth/piaoOrderInspect',{bizContent:{orderId:this.orderid}} )
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.companylist=new Array()
            this.readlist()
            this.adoptpanel=false
            this.tisopentrial=false
            swal({
              text: '已成功通过',
              icon:'success',
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    gochange(){
      this.npersonName=this.nowusinfo.personName
      this.nbirthday=this.$options.filters.formatDate(this.nowusinfo.birthday)
      this.nsexType=this.nowusinfo.sexType==1?'男':'女'
      this.nnationality=this.nowusinfo.nationality
      this.nidCardCode=this.nowusinfo.idCardCode
      this.nissuePlace=this.nowusinfo.issuePlace
      this.nstartTime=this.$options.filters.formatDate(this.nowusinfo.startTime)
      this.nendTime=this.$options.filters.formatDate(this.nowusinfo.endTime)
      this.newaddr=this.nowusinfo.addr
      this.ischage=true
    },
    goyyzz(){
      this.ncmpTypeName=this.licencedata.cmpTypeName
      this.nplace=this.licencedata.place
      this.nrunCode=this.licencedata.runCode
      this.ncreateTime=this.$options.filters.formatDate(this.licencedata.buildTime)
      this.nmodifyTime=this.licencedata.openEndTime
      this.nscope=this.licencedata.scope
      this.ngiveTime=this.$options.filters.formatDate(this.licencedata.giveTime)
      this.nregisterPlace=this.licencedata.registerPlace
      this.ischage=true
    },
    cardchange(){
      this.ajax.post('/auth/piaoEditPersonIdCard',{bizContent: {cardId:this.nowusinfo.cardId,personName:this.npersonName,sexType:this.nsexType=='男'?'1':'2',birthday:this.nbirthday,addr:this.newaddr,idCardCode:this.nidCardCode,nationality:this.nnationality,issuePlace:this.nissuePlace,startTime:this.nstartTime,endTime:this.nendTime}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.ischage=false
            this.lkidentity=false
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    orderreject(){
      this.ajax.post('/auth/piaoOrderReject',{bizContent:{orderId:this.orderid,desc:this.whatreject}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.companylist=new Array()
            this.rejectboxpanel=false
            this.tisopentrial=false
            this.readlist()
          }
        }
      )
    },
    colosepanel(val){
      this.istra=false
      if(val==1){
        this.adoptpanel=false
      }
      else if(val==2){
        this.rejectboxpanel=false
      }
      this.whatfail=''
    },
    download(val,key){
       let data = new Array()
       this.ajax({
         url:'/auth/piaoAuthDownLoad',
         method:'post',
         data:{bizContent:{orderId:val}},
         responseType:'blob',
         headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
       })
      .then(
        res=>{
          var blob = new Blob([res.data], {type: 'application/*;charset=utf-8'});
          var contentDisposition = res.headers['content-disposition'];  //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          console.log(contentDisposition)
          var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          var result = patt.exec(contentDisposition);
          console.log(result)
          var filename = key+'.zip';
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.style.display = 'none';
          downloadElement.href = href;
          downloadElement.download =filename ; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href);
        })
    },
    prepic(){
      this.imgpathindex=0
      this.imgpath=this.imgpathlist[0]
    },
    nextpic(){
      this.imgpathindex=1
      this.imgpath=this.imgpathlist[1]
    },
    nextpage(item){
      this.currentPage=item
      this.readlist()
    },
    lookidentity(val,key,code){
      this.ajax.post('/auth/piaoPersonIdCard',{bizContent:{uid:val,organizationCode:code}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            let a=''
            let b=''
            if(key==1){
              this.nowusinfo=result.data.data.cardResponse[0]
              a=result.data.data.silverResponse.legalPersonIdcardOpposite
              b=result.data.data.silverResponse.legalPersonIdcardPositive
            }
            else if(key==2){
              this.nowusinfo=result.data.data.cardResponse[1]
              a=result.data.data.silverResponse.agentIdcardOpposite
              b=result.data.data.silverResponse.agentIdcardPositive
            }
            if(a.indexOf('.com')!='-1'){
              if(key==1){
                this.imgpathlist[0]=result.data.data.silverResponse.legalPersonIdcardPositive
                this.imgpathlist[1]=result.data.data.silverResponse.legalPersonIdcardOpposite
                
              }
              else if(key==2){
                this.imgpathlist[0]=result.data.data.silverResponse.agentIdcardPositive
                this.imgpathlist[1]=result.data.data.silverResponse.agentIdcardOpposite
              }
            }
            else{
              if(key==1){
                this.imgpathlist[0]=this.versatile.imgUrl+result.data.data.silverResponse.legalPersonIdcardPositive
                this.imgpathlist[1]=this.versatile.imgUrl+result.data.data.silverResponse.legalPersonIdcardOpposite
                
              }
              else if(key==2){
                this.imgpathlist[0]=this.versatile.imgUrl+result.data.data.silverResponse.agentIdcardPositive
                this.imgpathlist[1]=this.versatile.imgUrl+result.data.data.silverResponse.agentIdcardOpposite
                
              }
            }
            this.imgpath=this.imgpathlist[this.imgpathindex]
            this.lkidentity=true
          }
        }
      )
    },
    openretract(){
      this.lookinfo=!this.lookinfo
    },
    looklicense(val,code){
      this.ajax.post('/auth/piaoBusnissLicence',{bizContent:{uid:val,organizationCode:code}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            let a=result.data.data.silverResponse.businessLicenceUrl
            if(a.indexOf('.com')!='-1'){
              this.imgpath=result.data.data.silverResponse.businessLicenceUrl
            }
            else{
              this.imgpath=this.versatile.imgUrl+result.data.data.silverResponse.businessLicenceUrl
            }
            this.licencedata=result.data.data.licenceResponse
            this.lkyyzc=true
          }
        }
      )
    },
    yyzcolese(){
      this.lkyyzc=false
      this.lkidentity=false
      this.imgpathindex=0
    },
    lookdetails(val){
      console.log(this.companylist[val]);
       this.$router.push({name:'OrganDetails', params: { companyinfo:this.companylist[val]}})
    },
    opentrial(val,key,id){
      this.tisopentrial = true
      this.istra=false
      this.orderid=id
       console.log(this.orderid);
      this.nuid=val
      this.norganizationCode=key
      this.statecapture()
    },
    
    statecapture(){
      this.ajax.post('/auth/gongShangShenHeDuiJieBankList',{bizContent: {uid: this.nuid,organizationCode: this.norganizationCode}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            console.log(result.data.data)
            this.trialbankinfo=result.data.data
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    bankadopt(){
      this.ajax.post('/auth/gongShangShenHeDuiJieBankInspect',{bizContent:{id:this.judgeid}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.isremindok=false
            this.statecapture()
            swal({
              text: '已成功通过',
              icon:'success',
              timer: 3000,
              buttons: false
            })
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    lookletter(key){
      this.letterimg=this.companylist[key].letterUrl
      this.lkletter=true
    },
    closeimg(){
      this.letterimg=""
      this.lkletter=false
    },
    closetrial(){
      this.tisopentrial=false
    },
    increaseshareholder(){
     var lt= {cerId:this.companylist[this.nowindex].organizationCode,
        enterpriseName:this.nowcompany,
        certType:"Ind01",
        name:'',
        idCode:'',
        regDate:'',
        expiryDate:'',
        regCityCode:'',
        regCityCodeDesc:'',
        relationShipCode:'',
        relationShipDesc:'',
        investmentCode:'',
        investmentCodeDesc:'',
        investmentProp:'',
        mobile:'',
        address:'',
        val1:'省',
        val2:'市',
        val3:'区'}
     this.stockholderinfo.push(lt)
    },
    delectshareholder(val){
      this.stockholderinfo.splice(val,1)
    },
    setidcartype(val,key,num){
      var lt=this.beneficiary[val]
      lt.certType=num
      lt.beneficiarycarid=key
      this.beneficiary.splice(val,1,lt)
    },
    selectidcartype(val,key,num){
      var lt=this.stockholderinfo[val]
      lt.certType=num
      this.stockholderinfo.splice(val,1,lt)
    },
    pushrenovation(val){
      var lt=this.stockholderinfo[val]
      this.stockholderinfo.splice(val,1,lt)
    },
    pushset(val){
      var lt=this.beneficiary[val]
      this.beneficiary.splice(val,1,lt)
    },
    selecttoinvest(val,key,num){
      var lt=this.stockholderinfo[val]
      lt.investmentCodeDesc=key
      lt.investmentCode=num
      this.stockholderinfo.splice(val,1,lt)
    },
    getpostcode(val){
      this.ajax.post(this.versatile.oaurl+'/auth/postCode',{bizContent:{fatherId:val}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.zipcode=result.data.data[0].post
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    reginfoinpu(val,phone,key,code){
      this.isinput=true
      this.nowindex=code
      this.canvasynthesis(key,this.companylist[code].organizationCode)
      this.getOneList()
      this.queryinfo()
      this.queryholder()
      this.qeneficiary()
      this.nowcompany=this.companylist[code].companyName
      var phone=this.companylist[code].legalPhone==''?this.companylist[code].mobile:this.companylist[code].legalPhone
      this.ajax.post('/discountBank/fbank/queryBasic',{bizContent:{certId:this.companylist[code].organizationCode,mobile:phone,stateOwnedFlag:'000001'}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.basicIncinfo=result.data.data.basicInc
            this.industryName=result.data.data.basicInc.industryName
            this.industrycode=result.data.data.basicInc.industryCODE
            this.offAreaCode= result.data.data.basicInc.offAreaCode
            this.coCode=result.data.data.basicInc.coCode
            this.coName=result.data.data.basicInc.coName
            // this.regcapital=result.data.data.basicInc.registerCapital*10000+'.00'
            // this.paidcapital=result.data.data.basicInc.paiclupCapital
            this.regaddress=result.data.data.basicInc.address1
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
      this.ajax.post('/discountBank/fbank/queryOrgNature')
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.mechanism=new Array()
            let et=result.data.data
            for(var key in et){
               this.mechanism.push({id:key,name:et[key]})
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
      })
      this.ajax.post('/discountBank/fbank/queryOrgOwnerShipType')
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.ownership=new Array()
            let et=result.data.data
            for(var key in et){
               this.ownership.push({id:key,name:et[key]})
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
      this.ajax.post('/discountBank/fbank/queryOrgType')
      .then(
        result=>{
          if(result.data.status=='0000'){
            let et=result.data.data
            this.enterprisesTypearray=new Array()
            for(var key in et){
               this.enterprisesTypearray.push({id:key,name:et[key]})
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
      this.ajax.post('/discountBank/fbank/queryCertType')
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.certificatetype=new Array
            let et=result.data.data
            for(var key in et){
               this.certificatetype.push({id:key,name:et[key]})
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
      this.ajax.post('/discountBank/fbank/queryDutyInc')
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.jobstyle=new Array()
            let et=result.data.data
            for(var key in et){
               this.jobstyle.push({id:key,name:et[key]})
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
      this.ajax.post('/discountBank/fbank/queryRelationShip')
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.contributiontype=new Array()
            let et=result.data.data
            for(var key in et){
               this.contributiontype.push({id:key,name:et[key]})
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
      this.getprovince()
    },
    getprovince(val){
      this.ajax.post(this.versatile.oaurl+'/auth/province')
      .then(
        result=>{
          this.provincelist=result.data.data
          if(val==1){
            this.selectprovince=true
            this.nowpro='所在省'
            this.nowct='市'
            this.nocou='区县'
            this.countylist=new Array()
          }
          else if(val==2){
            this.setectissueaddr=true
            this.issupro="签发省"
            this.issuct='市'
            this.issucou='区县'
            this.issuctylist=new Array()
          }
          else  if(val==3){
            this.setectmanageeaddr=true
            this.managepro="签发省"
            this.managect='市'
            this.managecou='区县'
            this.managectylist=new Array()
          }
          else{
            this.setectholdereaddr=true
            this.holderpro='签发省'
            this.holderct='市'
            this.holdercou='区县'
            this.holderctylist=new Array()
          }
        }
      )
    },
    getcity(val,name,base,key){
      if(base==1){
        this.cityval=''
        this.odcity=''
        this.nowpro=name;
        this.nowpid=val;
        this.issupro=name
        this.issupid=val
      }
      else if(base==2){
        // this.issupro=name
        // this.issupid=val
      }
      else if (base==3){
        this.managepro=name
        this.managepid=val
      }
      else if(base==4){
        this.holderpro=name
        this.stockholderinfo[key].val1=name
      }
        this.ajax.post(this.versatile.oaurl+"/auth/city",{"bizContent":{fatherId:val}}).then(
          statelist=> {
            if(statelist.data.status="0000"){
              if(base==1){
                this.selectprovince=false
                this.citylist=statelist.data.data
              }
              else  if(base==2){
                this.setectissueaddr=false
                this.citylist2=statelist.data.data
              }
              else  if(base==3){
                this.setectmanageeaddr=false
                this.citylist3=statelist.data.data
              }
              else{
                this.setectholdereaddr=false
                this.citylist4=statelist.data.data
              }
            }
          }
        )
      },
    openraup(){
      this.isrzup=true
    },
    norzup(){
      this.isrzup=false
    },
    setcity(val,name,base,key){
      if(base==1){
        this.nowct=name
        this.nowid=val
        this.issuct=name
        this.issucid=val
      }
      else if(base==2){
        // this.issuct=name
        // this.issucid=val
      }
      else if(base==3){
        this.managect=name
        this.managecid=val
      }
      else if(base==4){
        this.holderct=name
        var nd=this.stockholderinfo[key]
        nd.regCityCode=val
        nd.val2=name
        nd.regCityCodeDesc=name
        this.stockholderinfo.splice(key,1,nd)
      }
      this.ajax.post(this.versatile.oaurl+'/auth/areaFenBiao',{bizContent:{fatherId:val}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            if(base==1){
              this.countylist=result.data.data
            }
            else if(base==2){
              this.issuctylist=result.data.data
            }
            else if(base==3){
              this.managectylist=result.data.data
            }
            else{
              this.holderctylist=result.data.data
            }
            
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    bankrejec(){
      this.ajax.post('/auth/gongShangShenHeDuiJieBankReject',{bizContent:{id:this.judgeid}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.statecapture()
            this.isremindno=false
            swal({
              text: '驳回成功',
              icon:'success',
              timer: 3000,
              buttons: false
            })
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    setcounty(val,name,key,num){
      if(key==1){
        this.cityval=''
        this.odcity=''
        this.nocou=name
        this.nouid=val
        this.issucou=name
        this.issucid=val
        this.getpostcode(val)
      }
      else if(key==2){
        // this.issucou=name
        // this.issucid=val
        // this.getpostcode(val)
        
      }
      else if(key==3){
        let newinfo=this.ceodata[num]
        newinfo.regCityCodeDesc=this.managepro+this.managect+name
        newinfo.regCityCode=val
        this.ceodata.splice(num,1,newinfo)
        this.managecou=name
      }
      else{
        let newinfo=this.stockholderinfo[num]
        newinfo.regCityCode=val
        newinfo.val3=name
        newinfo.regCityCodeDesc=newinfo.val1+newinfo.val2+name
        this.stockholderinfo.splice(num,1,newinfo)
        this.holdercou=name

      }
    },
    setduties(val,key,num){
      let newinfo=this.ceodata[num]
      newinfo.relationShipCode=key
      newinfo.relationShipDesc=val
      this.ceodata.splice(num,1,newinfo)
    },
    editceoinfo(key){
      var lt=this.ceodata[key]
      this.ceodata.splice(key,1,lt)
    },
    confirmtype(val,key){
      this.businesstype=key
      this.businessid=val
      this.ajax.post('/discountBank/fbank/queryFinaceTypeCategory',{bizContent:{orgNature:val}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.branchtype=new Array()
            let et=result.data.data
            for(var key in et){
                this.branchtype.push({id:key,name:et[key]})
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    saveinfoa(){//提交基础信息
      this.ajax.post('/discountBank/fbank/recordBasic',{
        bizContent:{
          legalPersonCompositeUrl:this.legalpdf,
          businessLicenceUrl:this.burl,
          letterAuthorizationUrl:this.lurl,
          orgNature:this.businessid,
          orgNatureDesc:this.businesstype,
          loanCardNo:'',
          financeType:this.subclassid,
          financeTypeDesc:this.subclass,
          orgType: this.enterprisesid,
          orgTypeDesc:this.enterprisestype,
          orgOwnerShipType:this.ownershipid,
          orgOwnerShipTypeDesc:this.ownershipstyle,
          industryType1:this.industrycode,
          industryType1Name:this.industryName,
          industryType2:this.coCode,
          industryType2Name:this.coName,
          registerCapital:this.regcapital,
          paiclupCapital:this.paidcapital,
          employeeNumber:this.staffnumber,
          sellSum:this.salesvolume,
          totalAssets:this.totalassets,
          legalPersonName:this.companylist[this.nowindex].legalPersonName,
          legalPhone:this.companylist[this.nowindex].legalPhone,
          legalIdcardCode:this.legalinfo.idCardCode,
          organizationCode:this.companylist[this.nowindex].organizationCode,
          companyName:this.companylist[this.nowindex].companyName,
          regDate:this.basicIncinfo.regDate,
          expiryDate:this.basicIncinfo.idExpiry,
          regCityCode:this.nouid,
          regCityDesc:this.odcity!=''?this.odcity:this.nowpro+'-'+this.nowct+'-'+this.nocou,
          city:this.nouid,
          cityDesc:this.odcity!=''?this.odcity:this.nowpro+'-'+this.nowct+'-'+this.nocou,
          address:this.regaddress,
          zipCode:this.zipcode
        }
      })
      .then(
        result=>{
          if(result.data.status=="0000"){
            if(this.ceodata.length==0){
              this.setceodata()
            }
            if(this.stockholderinfo.length==0){
              this.setstockholderinfo()
            }
            this.operationstep=this.operationstep+1
          }
          else{
            swal({
              text: result.data.message,
              timer: 2000,
              buttons: false
            })
          }
        }
      )
    },
    setupbeneficiary(){
      var p={}
      p=this.beneficiary[0]
      p.address=this.legalinfo.addr
      p.addressCode=''
      p.certType='Ind01'
      p.beneficiarycarid='身份证'
      p.cerId=this.companylist[this.nowindex].organizationCode
      p.createTime=this.legalinfo.createTime
      p.nterpriseName=this.companylist[this.nowindex].companyName
      p.expiryDate= this.$options.filters.formatDate(this.legalinfo.endTime)
      p.idCode=this.legalinfo.idCardCode
      p.index=''
      p.investmentCode=''
      p.investmentCodeDesc=''
      p.investmentProp=''
      p.isDel=''
      p.limit=''
      p.legalPhone=this.companylist[this.nowindex].legalPhone
      p.modifyTime=this.legalinfo.modifyTime
      p.name=this.legalinfo.personName
      p.pageNum=''
      p.personType='2'
      p.regCityCode=this.stockholderinfo[0].regCityCode,
      p.regCityCodeDesc=this.stockholderinfo[0].regCityCodeDesc,
      p.regDate=this.$options.filters.formatDate(this.legalinfo.startTime)
      p.relationShipCode=''
      p.relationShipDesc=''
      p.version=''
      this.beneficiary.splice(0,1,p)
    },
    setbeneficiary(){
      let bf={
        address:'',
        addressCode:"",
        cerId:this.companylist[this.nowindex].organizationCode,
        certType:"Ind01",
        beneficiarycarid:'身份证',
        createTime:'',
        enterpriseName:this.stockholderinfo[0].enterpriseName,
        expiryDate:'',
        idCode:"",
        index:'',
        investmentCode:"",
        investmentCodeDesc:"",
        investmentProp:"",
        isDel:0,
        mobile:"",
        modifyTime:this.stockholderinfo[0].modifyTime,
        name:"",
        personType:2,
        regCityCode:this.stockholderinfo[0].regCityCode,
        regCityCodeDesc:this.stockholderinfo[0].regCityCodeDesc,
        regDate:'',
        relationShipCode:"",
        relationShipDesc:"",
        version:0
      }
      this.beneficiary.push(bf)
    },
    openbankadopt(val){
      this.isremindok=true
      this.judgeid=val
    },
    openbankrejec(val){
      this.isremindno=true
      this.judgeid=val
    },
    setceodata(){
      let cd={
        name:this.legalinfo.personName,
        idCode:this.legalinfo.idCardCode,
        regDate: this.$options.filters.formatDate(this.legalinfo.startTime),
        expiryDate:this.$options.filters.formatDate(this.legalinfo.endTime),
        address:this.legalinfo.addr,
        provinceId:this.legalinfo.provinceId,
        provinceName:this.legalinfo.provinceName,
        cityId:this.legalinfo.cityId,
        cityName:this.legalinfo.cityName,
        areaId:this.legalinfo.countryId,
        areaName:this.legalinfo.countryName,
        cerId:this.companylist[this.nowindex].organizationCode,
        enterpriseName:this.nowcompany,
        certType:'Ind01',
        regCityCode:'',
        regCityCodeDesc:'',
        relationShipCode:'0100',
        relationShipDesc:'法人代表',
        investmentCode:'',
        investmentCodeDesc:'',
        investmentProp:'',
        mobile:this.companylist[this.nowindex].legalPhone
      }
      this.ceodata.push(cd)
    },
    setstockholderinfo(){
      let hd={
        cerId:this.companylist[this.nowindex].organizationCode,
        enterpriseName:this.nowcompany,
        certType:"Ind01",
        name:'',
        idCode:'',
        regDate:'',
        expiryDate:'',
        regCityCode:'',
        regCityCodeDesc:'',
        relationShipCode:'',
        relationShipDesc:'',
        investmentCode:'',
        investmentCodeDesc:'',
        investmentProp:'',
        mobile:'',
        address:''
      }
      this.stockholderinfo.push(hd)
    },
    seniorexecutiveinfo(){//提交高管信息
      var l =this.ceodata.length
      for(let i =0;i<l;i++){
        this.ajax.post('/discountBank/fbank/recordPerson',{
          bizContent:{
            personType:'0',
            cerId:this.ceodata[i].cerId,
            companyName:this.ceodata[i].enterpriseName,
            certType:this.ceodata[i].certType,
            name:this.ceodata[i].name,
            idCode:this.ceodata[i].idCode,
            regDate:this.ceodata[i].regDate,
            expiryDate:this.ceodata[i].expiryDate,
            regCityCode:this.ceodata[i].regCityCode,
            regCityCodeDesc:this.ceodata[i].regCityCodeDesc,
            relationShipCode:this.ceodata[i].relationShipCode,
            relationShipCodeDesc:this.ceodata[i].relationShipDesc,
            investmentCode:this.ceodata[i].investmentCode,
            investmentCodeDesc:this.ceodata[i].investmentCodeDesc,
            investmentProp:this.ceodata[i].investmentProp,
            legalPhone:this.ceodata[i].mobile,
            address:this.ceodata[i].address
          }
        })
        .then(
          result=>{
            if(result.data.status=='0000'){
              this.substockholderinfo()
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
      }
    },//查询高管以及股东、受益人
    queryinfo(){
      this.ajax.post('/discountBank/fbank/queryPerson',{bizContent:{organizationCode:this.companylist[this.nowindex].organizationCode,personType:'0',limit:'10',pageNum:'1'}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            let ceoinfo=result.data.data.data
            for(let i= 0 ;i<ceoinfo.length;i ++){
              console.log(ceoinfo[i].address)
              ceoinfo[i].address=ceoinfo[i].address==''?this.legalinfo.addr:ceoinfo[i].address
            }
            this.ceodata=ceoinfo
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    getOneList(){
      this.ajax.post('/discountBank/fbank/queryRecordBasic',{bizContent:{certId:this.companylist[this.nowindex].organizationCode}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            // this.stockholderinfo=result.data.data.data
            let add = result.data.data
            this.businesstype=add.orgNatureDesc
            this.businessid=add.orgNature
            this.enterprisesid=add.orgType
            this.ownershipid=add.orgOwnerShipType
            this.subclassid=add.financeType
            // this.industryName=add.industryType1Name
            this.coName=add.industryType2Name
            this.ownershipstyle=add.orgOwnerShipTypeDesc
            this.enterprisestype=add.orgTypeDesc
            this.subclass=add.financeTypeDesc
            this.regaddress=add.address
            this.cityval=add.regCityDesc
            this.odcity=add.cityDesc
            this.nouid=add.regCity
            this.zipcode=add.zipCode
            this.regcapital=add.registerCapital
            this.paidcapital=add.paiclupCapital
            this.staffnumber=add.employeeNumber
            this.salesvolume=add.sellSum
            this.totalassets=add.totalAssets
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    queryholder(){//股东
      //this.stockholderinfo
      this.ajax.post('/discountBank/fbank/queryPerson',{bizContent:{organizationCode:this.companylist[this.nowindex].organizationCode,personType:'1',limit:'10',pageNum:'1'}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.stockholderinfo=result.data.data.data
            if(this.stockholderinfo.length==0){
                this.stockholderinfo=[
                  {cerId:this.companylist[this.nowindex].organizationCode,
                  enterpriseName:this.nowcompany,
                  certType:"Ind01",
                  name:'',
                  idCode:'',
                  regDate:'',
                  expiryDate:'',
                  regCityCode:'',
                  regCityCodeDesc:'',
                  relationShipCode:'',
                  relationShipDesc:'',
                  investmentCode:'',
                  investmentCodeDesc:'',
                  investmentProp:'',
                  mobile:'',
                  address:'',
                  val1:'省',
                  val2:'市',
                  val3:'区'
                  }]
            }
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    qeneficiary(){//受益人
      this.ajax.post('/discountBank/fbank/queryPerson',{bizContent:{organizationCode:this.companylist[this.nowindex].organizationCode,personType:'2',limit:'10',pageNum:'1'}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.beneficiary=result.data.data.data
            this.beneficiary.map((it,index)=>{
              if(it.certType=='Ind01'){
                it.beneficiarycarid='身份证'
              }else if(it.certType=='Ent04'){
                it.beneficiarycarid='社会统一信用代码'
              }else if(it.certType=='Ind03'){
                it.beneficiarycarid='护照'
              }else if(it.certType=='Ind06'){
                it.beneficiarycarid='港澳居民来往内地通行证'
              }else if(it.certType=='Ind07'){
                it.beneficiarycarid='台湾同胞来往内地通行证'
              }else if(it.certType=='Ind11'){
                it.beneficiarycarid='其他个人证件'
              }else if(it.certType=='Ind12'){
                it.beneficiarycarid='香港身份证'
              }else if(it.certType=='Ind13'){
                it.beneficiarycarid='澳门身份证'
              }else if(it.certType=='Ind14'){
                it.beneficiarycarid='台湾身份证'
              }
            })
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    substockholderinfo(){
      if(this.stockholderinfo.length==0){
        swal({
              text: '股东信息不能为空',
              timer: 3000,
              buttons: false
            })
        return;
      }else{
        this.stockholderinfo.map((it,index)=>{
          it.personType='1'
        })
        this.ajax.post('/discountBank/fbank/recordShareholderPerson',{
          bizContent:{
            'shareholder':this.stockholderinfo
          }
        })
        .then(
          result=>{
            if(result.data.status=='0000'){
              if(this.beneficiary.length==0){
                this.setbeneficiary()
              }
              this.operationstep=this.operationstep+1
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
      }
    },
    subbeneficiary(){//提交受益人信息
      let n=this.beneficiary.length
      for(let i=0;i<n;i++){
        console.log(i)
        this.ajax.post('/discountBank/fbank/recordPerson',{
          bizContent:{
            personType:'2',
            cerId:this.beneficiary[i].cerId,
            companyName:this.beneficiary[i].enterpriseName,
            certType:this.beneficiary[i].certType,
            name:this.beneficiary[i].name,
            idCode:this.beneficiary[i].idCode,
            regDate:this.beneficiary[i].regDate,
            expiryDate:this.beneficiary[i].expiryDate,
            addressCode:this.beneficiary[i].regCityCode,
            regCityCodeDesc:this.beneficiary[i].regCityCodeDesc,
            regCityCode:this.beneficiary[i].regCityCode,
            regCityDesc:this.beneficiary[i].regCityCodeDesc,
            relationShipCode:this.beneficiary[i].relationShipCode,
            relationShipCodeDesc:this.beneficiary[i].relationShipDesc,
            investmentCode:this.beneficiary[i].investmentCode,
            investmentCodeDesc:this.beneficiary[i].investmentCodeDesc,
            investmentProp:this.beneficiary[i].investmentProp,
            legalPhone:this.beneficiary[i].mobile,
            address:this.beneficiary[i].address
          }
        }).then(
          result=>{
            if(result.data.status=='0000'){
              this.isinput=false
              this.isrzup=false
              swal({
                text: result.data.message,
                icon: "success",
                timer: 3000,
                buttons: false
              })
              this.ajax.post('/discountBank/fbank/push',{bizContent:{"certId":this.companylist[this.nowindex].organizationCode}})
              .then(
                result=>{
                  if(result.data.status=='000000'){
                    if(result.data.data=='-1'){
                      swal({
                        text: '推送失败',
                        timer: 3000,
                        buttons: false
                      })
                    }else{
                      swal({
                        text: '推送成功',
                        icon: "success",
                        timer: 3000,
                        buttons: false
                      })
                    }
                    this.operationstep=1
                  }
                  else{
                    swal({
                      text: result.data.message,
                      timer: 3000,
                      buttons: false
                    })
                  }
                }
              )
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
      }
    },
    bankcolse(val){
      this.isremindok=false
      this.isremindno=false
    },
    canvasynthesis(val,code){
      let self = this;
      let title=''
      this.ajax.post('/auth/piaoPersonIdCard',{bizContent:{uid:val,organizationCode:code}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            title=result.data.data.silverResponse.organizationCode
            this.legalinfo=result.data.data.cardResponse[0]
            this.burl=result.data.data.silverResponse.businessLicenceUrl
            this.lurl=result.data.data.silverResponse.letterAuthorizationUrl
            let a="https:"+result.data.data.silverResponse.legalPersonIdcardPositive
            let b="https:"+result.data.data.silverResponse.legalPersonIdcardOpposite 
            this.ajax.post('/auth/mergeImage',{bizContent:{imgOneUrl:a,imgTwoUrl:b}})
            .then(
              result=>{
                this.legalpdf=this.versatile.imgUrl+result.data.data.filePath
              }
            )
        }
      })
    },
    clearInpusd(){
      this.isinput=false
    }
  }
}
</script>

<style scoped>
.lookpanel a{
  margin:0 1px;
}
.previous{
  position: absolute;
  left:10%;
  top:40%;
  font-size: 32px;
  color:#fff;
}
.next{
  position: absolute;
  right:10%;
  top:40%;
  font-size: 32px;
  color:#fff;
}
.adopt{
  position:absolute;
  left:50%;
  margin-left:-137px;
  top:50%;
  margin-top:-59px;
  width:274px;
  height:118px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(14,133,238,1);
  box-shadow:0px 28px 76px rgba(0,0,0,0.17);
  border-radius:5px;
  z-index:999999999
}
.adopt h2{
  width:84%;
  margin:0 8%;
  margin-top:15px;
  text-align: center;
  font-size:16px;
}
.adopt .btnbox{
  display:table;
  margin:0 auto;
}
.rejectbox{
  position: absolute;
  left: 50%;
  top:50%;
  margin-left:-322px;
  margin-top:-167px;
  width:645px;
  height:334px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 10px rgba(204,204,204,1);
  border-radius:2px;
  z-index:999999
}
.rejectbox h2,.rejectbox textarea{
  width:581px;
  margin:0 auto;
  display: block;
}
.rejectbox h2{
  font-size: 16px;
  color:#222222;
  margin-top:32px;
}
.rejectbox textarea{
  margin-top:20px;
   width:561px;
  padding:5px 10px;
  height:150px;
  border:1px solid rgba(227,228,229,1);
  margin-bottom: 10px;
}
.rejectbox .btn-confirm button{
  width:240px;
  height:52px;
  line-height:52px;
  border-radius: 2px;
  cursor: pointer;
}
.rejectbox .addno{
  border:1px solid rgba(61,143,226,1);
  box-shadow:0px 2px 7px rgba(61,143,226,0.5);
  margin-left:20px;
}
.redio a:hover{
  text-decoration: underline;
  color:rgba(61,143,226,1);
}
.zzcdatainfo.upbig{
  position: absolute;
  right:20%;
  background: rgba(255, 255, 255,0.5);
   border-radius: 2px;
   width:80px;
   height:80px;
   line-height:80px;
   text-align: center;
   bottom: 5%;
   cursor: pointer;
   box-shadow: 0 10px 20px 0 rgba(31,93,234,.16);
}
.zzcdatainfo.dowsmll{  
  position: absolute;
  bottom:10%;
  width:880px;
  padding:10px;
  left:50%;
  margin-left:-450px;
  height:320px;
  background: rgba(255, 255, 255,0.5);
  border-radius: 2px;
  box-shadow: 0 10px 20px 0 rgba(31,93,234,.16);
  display: table;
}
.icon-jiantou11::before,.retract {
  position: absolute;
  right: 25px;
  
  color:#333;
  font-size: 36px;
}
.icon-jiantou11::before{
  top: -22px;
}
.editbtn{
  width: 160px;
  height: 50px;
  color: #fff;
  background: #3D8FE2;
  border-radius: 4px;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0px 0px 12px rgba(61, 143, 226, .6)
}
.datatext{
  width:170px;
  background: rgba(255, 255, 255,0.5);
  text-indent: 8px;
}
.zzdatatext{
  width:270px;
  background: rgba(255, 255, 255,0.5);
  text-indent: 8px;
}
.datetext{
  width:85px;
  background: rgba(255, 255, 255,0.5);
  text-indent: 8px;
} 
.coloseide{
  width:20px;
  height:20px;
  position: absolute;
  right:10%;
  top:2%;
  color: #fff;
}
.noedit{
  display: none;
}
.route{
  width:30px;
  height:30px;
  position:absolute;
  right:10%;
  bottom:10%;
  font-size:52px;
  color:#fff;
}
.routpic1{
  transform-origin:center;
  transform: rotate(90deg);
}
.routpic2{
  transform-origin:center;
  transform: rotate(180deg);
}
.routpic3{
  transform-origin:center;
  transform: rotate(270deg);
}
.trialpanel{
  width:574px;
  height:651px;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 14px 2px rgba(0,0,0,0.09);
  position:absolute;
  vertical-align: middle;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  }
.trialpanel h2{
  width:574px;
  height:94px;
  line-height:94px;
  text-align:center;
  color:#fff;
  font-size:20px;
  background:rgba(61,143,226,1);
  margin-bottom:10px;
}
.triallist{
  width:96%;
  display: table;
  margin:0 auto;
  border:1px solid #efefef;
  border-radius: 4px;
  max-height: 400px;
  overflow: hidden;
  overflow-y:scroll; 
}
.triallist ul{
  display: table;
  width:100%;
}
.triallist ul li{
  float: left;
  text-align: center;
  height:52px;
  line-height: 52px;
  font-size: 14px;
  width:20%;
}
.triallist ul li:first-child{
  width:40%;
}
.triallist ul li:last-child span{
  margin:0 10px;
}
.savebox{
  display: table;
  margin:0 auto;
  margin-top:38px;
  height:60px;
}
.savebox > div {
  width: 200px;
  height:60px;
  line-height: 60px;
  text-align: center;
  float: left;
  cursor: pointer;
}
.tosave{
  color: #fff;
  background:rgba(61,143,226,1);
  border:1px solid rgba(61,143,226,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  border-radius:2px;
  margin-right:20px;
}
.tosave:hover{
  background:rgb(54, 136, 218);
}
.tocanel{
  color: #3D8FE2;
  background-color: #f3f3f3;
  border:1px solid #efefef;
}
.tocanel:hover{
  background:#efefef;
}
.limpid{
  opacity: 0.2;
}
.organizationCode{
  max-width: 140px;
  width:140px;
}
.phone,.userphone,.planBank{
  max-width: 90px;
  width:90px;
}
.lookpanel{
  position: relative;
}
.lookpanel>div{
  display: block;
  width:100%;
  height:42px;
  background: #fff;
}
.lookpanel >div>a{
  width:100%;
  height:42px;
  line-height:42px;
}
.userole{
  width:40px;
  max-width: 40px;
}
.leetimg{
  vertical-align: middle;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-height: 90%;
}
.leetbox{
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}
.closepanel{
  position: absolute;
  cursor: pointer;
  right:-30px;
  font-size: 30px;
  opacity: 0.5;
  -webkit-transition: all .2s linear;
    transition: all .2s linear;
    transform:rotate(0deg);
  -webkit-transform:rotate(0deg);
}
.closepanel:hover{
  opacity: 1;
  transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  -webkit-transition: all .2s linear;
    transition: all .2s linear;
}
.material a{
  margin-right:10px;
}
.material a:last-child{
  margin: 0;
}
.infoinputbox{
  position: absolute;
  width:1200px;
  height:492px;
  background:rgba(255,255,255,1);
  box-shadow:0px 4px 11px 0px rgba(0,0,0,0.16);
  vertical-align: middle;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.infoinputbox h2{
  text-align: center;
  height:60px;
  line-height: 90px;
}
.infomark{
  width:98%;
  height: 14px;
  margin:0 auto;
  position: relative;
  margin-top:30px;
}
.infomark::before{
  content: '';
  display: table;
  background-color: #3D8FE2;
  width:5px;
  height:14px;
  float: left;
  position: relative;
  z-index: 10;
  border-radius: 20px;
}
.infomark::after{
  content: '';
  width:100%;
  height:1px;
  position: absolute;
  left:0;
  top:50%;
  background-color: rgba(216, 216, 216, 0.4);
  z-index: 1;
}
.infomark span{
  position: absolute;
  top:-6px;
  left:5px;
  padding:0 10px;
  z-index: 20;
  background: #fff;
  font-size: 14px;
}
.reginfo{
  width:98%;
  height: 80px;
  border:1px solid #efefef;
  margin:15px auto;
  border-radius: 2px;
  margin-bottom:30px;
}
.reginfolist{
  width: 100%;
  height:40px;
  line-height:40px;
}
.reginfolist>div{
  height:40px;
  line-height:40px;
  float: left;
  text-align: center;
  font-size: 12px;
  position: relative;
}
.ril1,.ril2,.ril3,.ril7{
  width:105px;
}
.ril4{
  width:130px;
}
.ril5{
  width:70px;
}
.ril6{
  width:90px;
}
.ril8{
  width:65px;
}
.ril9,.ril10{
  width:150px;
}
.ril11{
  width: 70px;
  margin-left:20px;
}
.ril11 input{
  width: 62px;
  padding-left:8px; 
  border-bottom: 1px solid #ececec
}
.selector{
  width:100%;
  height:40px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.drop-down{
  position: absolute;
  left:5%;
  top:35px;
  width:90%;
  display: none;
  background: #fff;
  box-shadow: 0 0 5px rgba(136, 136, 136, 0.5);
  max-height: 30vh;
  overflow-y: scroll;
  z-index: 90;
}
.selector:hover{
  height:auto;
  display: table;
  overflow: unset;
}
.selector:hover ul{
  display: block;
  max-height: 30vh;
}
.selector >ul>li{
  width:100%;
  height:40px;
  line-height: 40px;
  cursor: pointer;
  font-size: 12px;
}
.selector >ul>li:hover,.jointsearch li:hover{
  background: rgba(61, 143, 226, 0.1);
  color: #4A8DF0; 
  cursor: pointer;
}
.selector span{
  display: block;
  width:100%;
  text-align: center;
  font-size: 12px;
}
.downselect::before{
  position: absolute;
  right:10px;
  font-size: 18px;
  color: #3d8fe2;
  -webkit-transition: all .2s linear;
    transition: all .2s linear;
    transform:rotate(0deg);
  -webkit-transform:rotate(0deg);
}
.selector:hover .downselect::before{
  -webkit-transition: all .2s linear;
    transition: all .2s linear;
    transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
}
.distraction .downselect::before{
  right:-5px;
}
.distraction ul{
  width:220%;
  left:-60%;
}
.ril4 .drop-down{
  width:100%;
}
.jointsearch span{
  width:100%;
  display: block;
  cursor: pointer;
  float: left;
  height:40px;
  line-height: 40px;
  text-align: center;
  position: relative;
  font-size: 12px;
}
.jointsearch ul{
  width:100%;
  background-color: #fff;
  max-height: 30vh;
  overflow-y: scroll;
  box-shadow: 0 0 5px rgba(136, 136, 136, 0.5);
  display: none;
  position: absolute;
  left:0;
  top:40px;
}
.jointsearch:hover ul{
  display: block;
}
.jointsearch span.pro::before,.jointsearch span::before{
  position: absolute;
  right:-6px;
  font-size: 18px;
  color: #3d8fe2;
  -webkit-transition: all .2s linear;
  transition: all .2s linear;
  transform:rotate(0deg);
  -webkit-transform:rotate(0deg);
}
.jointsearch:hover span.pro::before{
  -webkit-transition: all .2s linear;
    transition: all .2s linear;
    transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
}
.fmbtn{
  display: table;
  margin:0 auto;
}
.fmbtn > div{
  width:223px;
  height:40px;
  border-radius: 2px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  float: left;
}
.fmbtn-ok{
  color: #fff;
  background:rgba(61,143,226,1);
  border:1px solid rgba(61,143,226,1);
  margin-right: 17px;

}
.fmbtn-no{
  background-color: #fff;
  border:1px solid rgba(61,143,226,1);
  color:rgba(61,143,226,1);
}
.jointsearch ul{
  z-index: 90;
}
.selfinput input{
  width:90%;
  margin:0 5%;
  height:26px;
  text-indent: 8px;
      border-bottom: 1px solid #ececec;
}
.rilhd{
  background-color:rgba(225, 225, 225, .2);
}
.management>div{
  width:14.28%;
  height:40px;
  line-height:40px;
  text-align: center;
  position: relative;
}
.management input{
  width:90%;
  margin-left:5%;
  border-bottom: 1px solid #efefef;
  height:30px;
  text-align: center;
}
.stockholder > div{
  width:12%;
  text-align: center;
}
.stockholder > div > input{
  width:90%;
  text-align: center;
  margin:0 5%;
  height: 30px;
  border-bottom: 1px solid #efefef;
}
.stockholder > div:last-child{
  cursor: pointer;
  width:4%;
}
.stockholder > div:last-child:hover{
  text-decoration: underline;
  color: #3D8FE2;
}
.stockholder > div:first-child{
  width:8%;
}
.stockholder > div:nth-child(2){
  width:16%;
}
.reginfo.spring{
  min-height: 40px;
  display: table;
}
.beneficiary > div{
  width:14.25%;
}
.smllinput{
  width:98%;
  margin:0 1%;
  font-size: 12px;
}
.maxw{
  width:205px;
}
.smlw{width:135px;}
.pro{
  overflow: hidden;
  max-height: 40px;
}
.bluebox{
  position: absolute;
  top:43px;
  right:44px;
  width:152px;
  height:34px;
  line-height:34px;
  color:#ffffff;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 7px rgba(61,143,226,0.5);
  border-radius:2px;
  text-align: center;
}
.okrz{
  width:274px;
  height:118px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(14,133,238,1);
  box-shadow:0px 28px 76px rgba(0,0,0,0.17);
  opacity:1;
  border-radius:5px;
  vertical-align: middle;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 19;
}
.okrz h2{
  width:100%;
  height:65px;
  font-size:16px;
  text-align: center;
  line-height: 65px;
  color:rgba(34,34,34,1);
}
.okrzbtnbox{
  display: table;
  margin: 0 auto;

}
.okrzbtn{
  width: 80px;
  height:26px;
  line-height:26px;
  text-align: center;
  font-size:14px;
  background-color: #3D8FE2;
  color:#fff;
   float: left;
   margin-top:10px;
}
.unul>li>span:hover{
  cursor: pointer;
  text-decoration: underline;
  color: #3D8FE2;
}
.fgfg{
  margin-right: 20PX;
}
.okrzbtn{
  cursor: pointer;
}
.hole{
  opacity: 0.5;
}
.clearss{
  font-size: 24px;
  color: #333;
  float: right;
  margin-right: 15px;
}
.clearss:hover{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/page/bankacceptance/businessauth.vue